import Api from './api'

const scoped = {
  data: null,
}

export function eagerGet() {
  return scoped.data || {}
}

function loadingWithNS(namespace) {
  return (to) => {
    if (namespace == 'registration/token') {
      return namespace + '?token=' + to.query.token
    } else if (to.name == 'mutation/detail') {
      return namespace + '/' + to.params.id
    } /*else if (to.params.namespaceonly === true && to.params.idTechnique) {
      return to.name + '/' + to.params.idTechnique;
    }*/ else if (to.params.namespaceonly === true) {
      return to.name
    } else if (to.params.id && to.params.id !== 'new') {
      return namespace + '/' + to.params.id
    } else {
      return null
    }
  }
}

// une fonction qui permet de charger le namespace
export default function eagerLoading(namespace) {
  return eagerLoad(loadingWithNS(namespace))
}

// une fonction qui permet de gerer les beforeRouteEnter
export function eagerLoad(uriBuilder) {
  return (to, from, next) => {
    const uri = uriBuilder(to)
    if (uri) {
      new Api(uri)
        .get()
        .then((response) => {
          scoped.data = response.body
        })
        .catch(() => {
          // TODO gestion du cas d'erreur not found
        })
        .finally(next)
    } else {
      scoped.data = null
      next()
    }
  }
}
